import type { OverrideProperty } from '@bindoc-projects/util-domain-lib';
import type {
  FilterConditionExpression,
  FilterConditionPluginFilterType,
  FilterPluginSpecificationRestriction,
  FilterRegistrationToken,
} from '@bindoc-projects/filter-condition-domain-lib';
import {
  FilterConditionClinicSizesPlugin,
  FilterConditionClinicTypesPlugin,
  FilterConditionClinicUniversityTypePlugin,
  FilterConditionPluginAbstractFilter,
  FilterConditionUtil,
  FilterConditionVirtualClinicBenchmarkingGroupIdsPlugin,
  FilterConditionVirtualClinicYearsPlugin
} from '@bindoc-projects/filter-condition-domain-lib';
import type { FilterConditionDto } from '@bindoc-projects/condition-domain-lib';

export class VirtualClinicAnalysisClinicsFilter extends FilterConditionPluginAbstractFilter {
  public static TYPES: FilterPluginSpecificationRestriction = [
    { specification: FilterConditionVirtualClinicYearsPlugin.Specification },
    {
      specification:
        FilterConditionVirtualClinicBenchmarkingGroupIdsPlugin.Specification,
    },
    { specification: FilterConditionClinicUniversityTypePlugin.Specification },
    { specification: FilterConditionClinicTypesPlugin.Specification },
    { specification: FilterConditionClinicSizesPlugin.Specification },
  ];

  public static fromObject(
    obj: {
      type: FilterConditionPluginFilterType;
      condition: FilterConditionDto;
    },
    registeredFilter: FilterRegistrationToken[],
  ): Promise<VirtualClinicAnalysisClinicsFilter> {
    const expressionData: FilterConditionDto = obj.condition;

    if (!expressionData) {
      return Promise.resolve(new VirtualClinicAnalysisClinicsFilter());
    }

    return FilterConditionUtil.fromConditionJson(
      obj.condition,
      registeredFilter,
    ).then((expression) => {
      return new VirtualClinicAnalysisClinicsFilter(expression);
    });
  }

  constructor(
    expression: FilterConditionExpression = FilterConditionUtil.EMPTY(),
  ) {
    super('clinics-filter', expression);
  }

  override toJSON(): { type: string; condition: object } {
    const condition = this.expression.toCondition({});
    return {
      type: this.type,
      condition: condition?.toJSON() ?? {},
    };
  }

  clone(): VirtualClinicAnalysisClinicsFilter {
    return new VirtualClinicAnalysisClinicsFilter(this.expression.clone());
  }

  public override overrideClone(
    override: OverrideProperty[],
  ): VirtualClinicAnalysisClinicsFilter {
    return new VirtualClinicAnalysisClinicsFilter(
      this.expression.overrideClone(override),
    );
  }
}
